import Vue from "vue";
import Toasted from "vue-toasted";

var Options = {
  duration: 2500,
};

// you can also pass options, check options reference below
Vue.use(Toasted, Options);
